import { render, staticRenderFns } from "./VisitorAreas.vue?vue&type=template&id=433b8e28&"
import script from "./VisitorAreas.vue?vue&type=script&lang=js&"
export * from "./VisitorAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports